import script from "./machine.vue?vue&type=script&lang=ts&setup=true"
export * from "./machine.vue?vue&type=script&lang=ts&setup=true"

import "./machine.vue?vue&type=style&index=0&id=6ba36336&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba36336"]])

export default __exports__